import { DaysPicked, ISchedule } from '../../types/schedule'
import { AppDispatch } from '../../types/store'
import { schedulesActions } from '../slices/schedulesSlice'

// ============ actions ============ //

export const refreshSchedulesCommonState = () => (dispatch: AppDispatch) => {
    dispatch(schedulesActions.refreshSchedulesCommonState())
}

export const addSchedule =
    (payload: { guid: string; schedules: ISchedule[] }) =>
    (dispatch: AppDispatch) => {
        dispatch(schedulesActions.addJobSchedule(payload))
    }

export const changeScheduleDateFrom =
    (payload: { guid: string; index: number; dateFrom: string }) =>
    (dispatch: AppDispatch) => {
        dispatch(schedulesActions.changeJobScheduleDateFrom(payload))
    }

export const changeScheduleDateTo =
    (payload: { guid: string; index: number; dateTo: string | null }) =>
    (dispatch: AppDispatch) => {
        dispatch(schedulesActions.changeJobScheduleDateTo(payload))
    }

export const changeScheduleDays =
    (payload: { guid: string; index: number; days: DaysPicked }) =>
    (dispatch: AppDispatch) => {
        dispatch(schedulesActions.changeJobScheduleDays(payload))
    }

export const changeScheduleTimes =
    (payload: { guid: string; index: number; times: Array<string | null> }) =>
    (dispatch: AppDispatch) => {
        dispatch(schedulesActions.changeJobScheduleTimes(payload))
    }

export const deleteSchedule =
    (payload: { guid: string; updatedScheduleList: ISchedule[] }) =>
    (dispatch: AppDispatch) => {
        dispatch(schedulesActions.deleteJobSchedule(payload))
    }

export const toggleScheduleState =
    (payload: { guid: string; index: number; isActive: boolean }) =>
    (dispatch: AppDispatch) => {
        dispatch(schedulesActions.toggleJobScheduleState(payload))
    }

export const duplicateSchedule =
    (payload: { guid: string; index: number }) => (dispatch: AppDispatch) => {
        dispatch(schedulesActions.duplicateJobSchedule(payload))
    }